import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {observer} from 'mobx-react';
import Popover from '@material-ui/core/Popover';
import MdDelete from 'react-icons/lib/md/delete';
import Button from '@material-ui/core/Button';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import classNames from 'classnames';
import DeleteConfirmationDialog from '../../../../components/dialog/DeleteConfirmationDialog';
import {withDialog} from '../../../../components/dialog/withDialog';
import {withTooltip} from '../../../../components/toolTip/withTooltip';
import {PowerState} from '../../../../constants/enums';
import LooperPower from '../../looper/LooperPower';
import LooperTrackControl from '../../looper/LooperTrackControl';
import {typoDark} from '../../../../themes/colors';
import StudioLooperTrackNotation from "./StudioLooperTrackNotation";

@withTooltip
@withDialog
@observer
class StudioLooperTrack extends Component {
    onNotationClick = () => {
        this.props.dismissTooltip();
    };

    openConfirmationDialog = () => {
        this.props.openDialog();
    };

    handleRemove = () => {
        this.props.onRemove();
        this.props.closeDialog();
    };

    render() {
        const {track, onVolumeChange, onVolumeToggle,
            onOpenTooltip, isTooltipOpen, onDismissTooltip, showDialog, closeDialog} = this.props;
        const trackClasses = classNames({
            'm-looper-track': true,
            active: isTooltipOpen,
            muted: !track.volume
        });

        return (
            <div className={trackClasses}>
                <div id={`m-track-${track.id}`} onClick={onOpenTooltip} className="track-bg-image" style={{borderColor: track.color}}>
                    <img src={track.backgroundImage} alt=""/>
                </div>
                <Popover
                    className="m-track-controls"
                    classes={{paper: 'm-track-controls-area'}}
                    marginThreshold={0}
                    transitionDuration={0}
                    anchorEl={document.querySelector(`#m-track-${track.id}`)}
                    anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'left',
                    }}
                    transformOrigin={{
                        vertical: 'bottom',
                        horizontal: 'left',
                    }}
                    open={isTooltipOpen}
                    onClose={onDismissTooltip}>
                    <ClickAwayListener onClickAway={onDismissTooltip}>
                        <div className="m-track-controls-wrapper">
                            <div className="track-details">
                                <span className="track-details-name">{track.name}</span>
                                <span className="track-details-owner">{track.owner.name}</span>
                            </div>
                            {track.attachments && track.attachments.length > 0 &&
                            <div className="track-notation">
                                {track.attachments.map(notation => {
                                    return <StudioLooperTrackNotation key={notation.id} track={track} notation={notation} onNotationClick={this.onNotationClick}/>
                                })}
                            </div>
                            }
                            <div className="track-controls">
                                <LooperPower
                                    className="track-volume-toggle"
                                    color={typoDark}
                                    onClick={onVolumeToggle}
                                    powerState={track.volume > 0 ? PowerState.On : PowerState.Off}
                                />
                                <LooperTrackControl
                                    className="track-volume-control"
                                    trackColor={track.color}
                                    track={track}
                                    onVolumeChange={onVolumeChange}
                                />
                                <Button
                                    className="track-remove-btn"
                                    onClick={this.openConfirmationDialog}>
                                    <MdDelete style={{fontSize: 24}}/>
                                </Button>
                            </div>
                        </div>
                    </ClickAwayListener>
                </Popover>
                <DeleteConfirmationDialog
                    open={showDialog}
                    onDismiss={closeDialog}
                    onOutsideClick={closeDialog}
                    onSubmit={this.handleRemove}
                    params={{type: 'stem', buttonText: 'remove'}}
                />
            </div>
        );
    }
}

StudioLooperTrack.propTypes = {
    track: PropTypes.object.isRequired,
    onVolumeChange: PropTypes.func,
    onRemove: PropTypes.func,
    onVolumeToggle: PropTypes.func
};

export default StudioLooperTrack;
